import * as TabsPrimitive from "@radix-ui/react-tabs";
import { ReactNode } from "react";

type Props = {
	children: ReactNode;
	value: string;
	onClick?: () => void;
};

/**
 * タブのトリガーコンポーネント
 * @param props props
 * @returns タブのトリガーコンポーネント
 */
export default function TabsTrigger(props: Props) {
	const { value, children, onClick } = props;

	return (
		<TabsPrimitive.Trigger
			value={value}
			onClick={() => onClick && onClick()}
		>
			{children}
		</TabsPrimitive.Trigger>
	);
}
